import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Inscription from 'app/core/models/inscription';
import { InscriptionService } from 'app/service/inscription.service';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'app/service/auth/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import * as xlsx from 'xlsx';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-inscription-list',
  templateUrl: './inscription-list.component.html',
  styleUrls: ['./inscription-list.component.css']
})
export class InscriptionListComponent implements OnInit {

  public displayedColumns = ['numero', 'completed', 'name', 'type', 'canal', 'price', 'checkTarifSocial', 'paiement', 'isScan', 'isSend', 'existJustificatif', 'actions'];
  public displayedColumnsForExport = ['numero', 'statut', 'completed', 'numeroReference', 'civilite', 'name', 'type', 'price', 'checkTarifSocial', 'dateNaissance', 'mail', 'adresse', 'adresseManuelle', 'telephone', 'prix', 'paiement', 'isScan', 'isSend', 'choixListeDiffusion', 'choixPhoto', 'canal', 'existPaiement', 'modePaiement', 'numerocheque', 'datePaiement', 'observations'];
  public dataSourceInscriptions: MatTableDataSource<Inscription>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  public inscriptions: Array<Inscription>;
  public selectedItemsExportExcel = [];
  public dropdownSettings = {
    singleSelection: false,
    idField: '_id',
    textField: 'libelle',
    selectAllText: 'Tout sélectionner',
    unSelectAllText: 'Tout désélectionner',
    itemsShowLimit: 2,
    allowSearchFilter: false,
    searchPlaceholderText: 'Recherche',
    enableCheckAll: true
  };
  @ViewChild('excelExportTable', { static: false }) excelExportTable: ElementRef;
  public limitTotal = environment.nbLimitTotalInscription;
  public isCheckedCanceled = false;

  constructor(
    private toastr: ToastrService,
    private inscriptionService: InscriptionService,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
  ) { }

  async ngOnInit() {
    await this.refreshData();
  } // fin ngOnInit

  async checkInscriptionsCanceled(event) {
    this.isCheckedCanceled = event.checked;
    await this.refreshData();
  }

  async refreshData() {
    const data = {
      isCheckedCanceled: this.isCheckedCanceled
    }
    const inscriptions:any = await this.inscriptionService.getInscriptions(data).toPromise();
    this.inscriptions = inscriptions;
    this.dataSourceInscriptions = new MatTableDataSource(this.inscriptions);
    this.dataSourceInscriptions.paginator = this.paginator;
    this.dataSourceInscriptions.sort = this.sort;
    this.spinner.hide();
  }

  closeModal() {
    this.modalService.dismissAll();
    this.selectedItemsExportExcel = [];
  }

  applyFilter(filterValue: string) {
    this.dataSourceInscriptions.filter = filterValue.trim().toLowerCase();
  }

  async deleteInscription(data) {
    const inscriptions: any = await this.inscriptionService.getInscriptionsByNumero(data).toPromise();
    if (inscriptions.length > 1) { // suppression de deux inscriptions
      const dataSend = {
        _id: inscriptions[0]._id,
        _idReference: inscriptions[1]._id
      };
      Swal.fire({
        title: "Êtes-vous sûr de vouloir supprimer l'inscription n°" + inscriptions[0].numero + " et l'inscription n°" +  inscriptions[1].numero +"?",
        text: 'Attention, ces deux inscriptions sont associées, elles seront donc toutes les deux supprimées!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Oui',
        cancelButtonText: 'Non'
      }).then((result1) => {
        if (result1.value) {
          this.spinner.show();
          this.inscriptionService.deleteInscription(dataSend).subscribe((response: any) => {
            if (response === 'Successfully deleted') {
              this.spinner.hide();
              this.toastr.success('Inscriptions annulées avec succès');
              this.refreshData();
            } else {
              this.spinner.hide();
              this.toastr.warning('Le serveur a rencontré un problème');
            }
          });
        } else if (result1.dismiss === Swal.DismissReason.cancel) {
          this.toastr.warning('Votre action sera annulée');
        }
      });
    } else { // un seule inscription à supprimer
      const dataSend = {
        _id: inscriptions[0]._id,
      };
      Swal.fire({
        title: "Êtes-vous sûr de vouloir supprimer l'inscription n°" + inscriptions[0].numero + "?",
        text: 'Attention, cette inscription sera définitivement supprimée!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Oui',
        cancelButtonText: 'Non'
      }).then((result1) => {
        if (result1.value) {
          this.spinner.show();
          this.inscriptionService.deleteInscription(dataSend).subscribe((response: any) => {
            if (response === 'Successfully deleted') {
              this.spinner.hide();
              this.toastr.success('Inscription supprimée avec succès');
              this.refreshData();
            } else {
              this.spinner.hide();
              this.toastr.warning('Le serveur a rencontré un problème');
            }
          });
        } else if (result1.dismiss === Swal.DismissReason.cancel) {
          this.toastr.warning('Votre action sera annulée');
        }
      });
    }
  } // fin deleteInscription

  async cancelInscription(data) {
    const inscriptions: any = await this.inscriptionService.getInscriptionsByNumero(data).toPromise();
    if (inscriptions.length > 1) { // annulation de deux inscriptions
      const dataSend = {
        _id: inscriptions[0]._id,
        _idReference: inscriptions[1]._id
      };
      Swal.fire({
        title: "Êtes-vous sûr de vouloir annuler l'inscription n°" + inscriptions[0].numero + " et l'inscription n°" +  inscriptions[1].numero +"?",
        text: 'Attention, ces deux inscriptions sont associées, elles seront donc toutes les deux annulées!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Oui',
        cancelButtonText: 'Non'
      }).then((result1) => {
        if (result1.value) {
          this.spinner.show();
          this.inscriptionService.cancelInscription(dataSend).subscribe((response: any) => {
            if (response === 'Successfully canceled') {
              this.spinner.hide();
              this.toastr.success('Inscriptions annulées avec succès');
              this.refreshData();
            } else {
              this.spinner.hide();
              this.toastr.warning('Le serveur a rencontré un problème');
            }
          });
        } else if (result1.dismiss === Swal.DismissReason.cancel) {
          this.toastr.warning('Votre action sera annulée');
        }
      });
    } else { // un seule inscription à annuler
      const dataSend = {
        _id: inscriptions[0]._id,
      };
      Swal.fire({
        title: "Êtes-vous sûr de vouloir annuler l'inscription n°" + inscriptions[0].numero + "?",
        text: 'Attention, cette inscription sera définitivement annulée!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Oui',
        cancelButtonText: 'Non'
      }).then((result1) => {
        if (result1.value) {
          this.spinner.show();
          this.inscriptionService.cancelInscription(dataSend).subscribe((response: any) => {
            if (response === 'Successfully canceled') {
              this.spinner.hide();
              this.toastr.success('Inscription annulée avec succès');
              this.refreshData();
            } else {
              this.spinner.hide();
              this.toastr.warning('Le serveur a rencontré un problème');
            }
          });
        } else if (result1.dismiss === Swal.DismissReason.cancel) {
          this.toastr.warning('Votre action sera annulée');
        }
      });
    }
  } // fin cancelInscription

  async discancelInscription(data) {
    const inscriptions: any = await this.inscriptionService.getInscriptionsByNumero(data).toPromise();
    if (inscriptions.length > 1) { // récupération de deux inscriptions
      // il faut vérifier qu'il reste au moins deux places
      const inscriptionsTotal: any = await this.inscriptionService.getNbPreInscriptionsTotal().toPromise();
      if ( inscriptionsTotal.length >= this.limitTotal)  {
        // supérieur au quotas donc impossible
        this.toastr.warning("Le quotas d'inscription est déjà atteint vous ne pouvez pas effectuer cette opération");
      } else { // ok pour récupération
        const dataSend = {
          _id: inscriptions[0]._id,
          _idReference: inscriptions[1]._id
        };
        Swal.fire({
          title: "Êtes-vous sûr de vouloir récupérer l'inscription n°" + inscriptions[0].numero + " et l'inscription n°" +  inscriptions[1].numero +"?",
          text: 'Attention, ces deux inscriptions sont associées, elles seront donc toutes les deux récupérées!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Oui',
          cancelButtonText: 'Non'
        }).then((result1) => {
          if (result1.value) {
            this.spinner.show();
            this.inscriptionService.discancelInscription(dataSend).subscribe((response: any) => {
              if (response === 'Successfully discanceled') {
                this.spinner.hide();
                this.toastr.success('Inscriptions récupérées avec succès');
                this.refreshData();
              } else {
                this.spinner.hide();
                this.toastr.warning('Le serveur a rencontré un problème');
              }
            });
          } else if (result1.dismiss === Swal.DismissReason.cancel) {
            this.toastr.warning('Votre action sera annulée');
          }
        });
      }
    } else { // un seule inscription à récupérer
      // il faut vérifier qu'il reste au moins deux places
      const inscriptionsTotal: any = await this.inscriptionService.getNbPreInscriptionsTotal().toPromise();
      if ( inscriptionsTotal.length >= this.limitTotal)  {
        // supérieur au quotas donc impossible
        this.toastr.warning("Le quotas d'inscription est déjà atteint vous ne pouvez pas effectuer cette opération");
      } else {
        const dataSend = {
          _id: inscriptions[0]._id,
        };
        Swal.fire({
          title: "Êtes-vous sûr de vouloir récupérer l'inscription n°" + inscriptions[0].numero + "?",
          text: 'Attention, cette inscription sera définitivement récupérée!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Oui',
          cancelButtonText: 'Non'
        }).then((result1) => {
          if (result1.value) {
            this.spinner.show();
            this.inscriptionService.discancelInscription(dataSend).subscribe((response: any) => {
              if (response === 'Successfully discanceled') {
                this.spinner.hide();
                this.toastr.success('Inscription récupérée avec succès');
                this.refreshData();
              } else {
                this.spinner.hide();
                this.toastr.warning('Le serveur a rencontré un problème');
              }
            });
          } else if (result1.dismiss === Swal.DismissReason.cancel) {
            this.toastr.warning('Votre action sera annulée');
          }
        });
      }
    }
  } // fin discancelInscription

  scanInscription(id) {
    this.spinner.show();
    const dataSend = {
      _id: id
    };
    this.inscriptionService.scanInscription(dataSend).subscribe((response: any) => {
      if (response === 'Successfully scanned') {
        this.spinner.hide();
        this.toastr.success('Inscription scannée avec succès');
        this.refreshData();
      } else {
        this.spinner.hide();
        this.toastr.warning('Le serveur a rencontré un problème');
      }
    });
  }

  unScanInscription(id) {
    this.spinner.show();
    const dataSend = {
      _id: id
    };
    this.inscriptionService.unScanInscription(dataSend).subscribe((response: any) => {
      if (response === 'Successfully unscanned') {
        this.spinner.hide();
        this.toastr.success('Inscription déscannée avec succès');
        this.refreshData();
      } else {
        this.spinner.hide();
        this.toastr.warning('Le serveur a rencontré un problème');
      }
    });
  }

  openChoiceExportExcel(modalChoiceColumnExportExcel) {
    this.modalService.open(modalChoiceColumnExportExcel);
  }

  downloadAsExcel() {
    const ws: xlsx.WorkSheet = xlsx.utils.table_to_sheet(this.excelExportTable.nativeElement);
    const wb: xlsx.WorkBook = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(wb, ws, 'Sheet1');
    xlsx.writeFile(wb, 'exportInscriptions.xlsx');
    this.closeModal();
  } // fin downloadAsExcel

  async uploadInvitation(invitation: Inscription) {
    this.spinner.show();
    const dataSend = {
      idInvitation: invitation._id,
      numero: invitation.numero,
      invite: invitation.civilite + ' ' + invitation.firstName + ' ' + invitation.lastName,
      adresse: (invitation.adresse !== undefined) ? invitation.adresse : invitation.adresseManuelle
    };
    const resultFile: any = await this.inscriptionService.uploadInvitation(dataSend).toPromise();
    const file = resultFile.file;
    const linkSource = `data:application/pdf;base64,${file}`;
    const downloadLink = document.createElement('a');
    const fileName = 'billetLesAinesEnFete.pdf';
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
    this.spinner.hide();
  }

  sendMailingInvitation(invitation: Inscription) {
    this.spinner.show();
    const dataSend = {
      idInvitation: invitation._id,
      numero: invitation.numero,
      invite: invitation.civilite + ' ' + invitation.firstName + ' ' + invitation.lastName,
      adresse: (invitation.adresse !== undefined) ? invitation.adresse : invitation.adresseManuelle,
      mail: invitation.mail
    };
    this.inscriptionService.sendMailingInvitation(dataSend).subscribe((response: any) => {
      if (response.Mailing === 'Successfully sending') {
        this.refreshData();
        this.spinner.hide();
        this.toastr.success('Invitation envoyée avec succès');
      } else {
        this.spinner.hide();
        this.toastr.warning('Le serveur a rencontré un problème');
      }
    });
  } // fin sendMailingInvitation

  sendMailingInvitations() {
    Swal.fire({
      title: "Êtes-vous sûr de vouloir envoyer toutes les invitations par mail ? ",
      text: 'Attention, cette action sera définitive',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Oui',
      cancelButtonText: 'Non'
    }).then((result1) => {
      if (result1.value) {
        this.spinner.show();
        this.inscriptionService.sendMailingInvitations().subscribe((response: any) => {
          if (response.Mailing === 'Successfully all sending') {
            this.refreshData();
            this.spinner.hide();
            this.toastr.success('Invitations envoyées avec succès');
          } else {
            this.spinner.hide();
            this.toastr.warning('Le serveur a rencontré un problème');
          }
        });
      } else if (result1.dismiss === Swal.DismissReason.cancel) {
        this.toastr.warning('Votre action sera annulée');
      }
    });
  } // fin sendMailingInvitations

  sendMailingErros() {
    this.spinner.show();
    this.inscriptionService.sendMailingErros().subscribe((response: any) => {
      if (response.Mailing === 'Successfully all sending') {
        this.refreshData();
        this.spinner.hide();
        this.toastr.success('Invitations envoyées avec succès');
      } else {
        this.spinner.hide();
        this.toastr.warning('Le serveur a rencontré un problème');
      }
    });
  }

  uploadJustificatif(data) {
    this.inscriptionService.viewPJ(data.justificatifLocation).subscribe((response: any) => {
      const file = response.file;
      const linkFile = `data:file;base64,${file}`;
      const downloadLink = document.createElement('a');
      const fileName = data.justificatifFileName;
      downloadLink.href = linkFile;
      downloadLink.download = fileName;
      downloadLink.click();
    });
  }

}
